import useSessionPermissionsLoadState from "permissions/session/use-session-permissions-load-state";
import { NotAuthorized } from "_shared/_errors/_views/not-authorized";
import CompanyProfilesPage from "marketplace/_views/profiles/company-profiles-page";
import IndividualProfilesPage from "marketplace/_views/profiles/individual-profiles-page";
import { PageTab } from "marketplace/_views/profiles/profiles-page-tabs";
import TeamProfilesPage from "marketplace/_views/profiles/team-profiles-page";
import { getSessionPermissions } from "permissions/_stores/permissions-redux-slice";
import { useSelector } from "react-redux";
import { useParams } from "react-router";


export default function ManageProfiles() {
  // The route always names a tab: the loader redirects an address that does not.
  const routeParams = useParams();

  const sessionPermissions = useSelector(getSessionPermissions);
  const permissionsLoadState = useSessionPermissionsLoadState();

  if (!sessionPermissions) return permissionsLoadState;

  if (!sessionPermissions.includesReadWriteAccessToMarketplace) return <NotAuthorized />;

  if (routeParams.pageTab === PageTab.Company) return <CompanyProfilesPage />;
  if (routeParams.pageTab === PageTab.Teams) return <TeamProfilesPage />;
  return <IndividualProfilesPage />;
}
